<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="活动标题">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.name"
        ></a-input>
      </a-form-item>
      <a-form-item label="活动Logo">
        <UploadFile @callback="uploaded" :mult="false" folder="activity" />
      </a-form-item>
      <a-form-item label="活动海报">
        <UploadFile @callback="uploaded2" :mult="false" folder="activity" />
      </a-form-item>
      <a-form-item label="活动简介">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
      <a-form-item label="选择位置">
        <a-button size="small" icon="compass" @click="pos_picker_show = true"></a-button>
        {{form.lat}}<span v-if="form.lng">,</span>{{form.lng}}
      </a-form-item>
      <a-form-item label="贝展场地">
        <a-input style="width: 600px" type="text" v-model="form.place"></a-input>
      </a-form-item>
      <a-form-item label="详细地址">
        <a-input style="width: 600px" type="text" v-model="form.addr"></a-input>
      </a-form-item>
      <a-form-item label="主办方">
        <a-input style="width: 600px" type="text" v-model="form.zhuban" placeholder="多个主办方用中文、隔开"></a-input>
      </a-form-item>
      <a-form-item label="协办方">
        <a-input style="width: 600px" type="text" v-model="form.xieban" placeholder="多个协办方用中文、隔开"></a-input>
      </a-form-item>
      <a-form-item label="报名费">
        <a-input-number :min="0" v-model="form.fee"></a-input-number>
      </a-form-item>
      <a-form-item label="活动时间">
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.start_at" />
        <span style="margin: 0 10px">-</span>
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.end_at" />
      </a-form-item>
      <a-form-item label="报名时间">
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.join_start" />
        <span style="margin: 0 10px">-</span>
        <a-date-picker :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.join_end" />
      </a-form-item>
      <a-form-item label="限制总人数">
        <a-input-number :min="0" style="width: 320px" v-model="form.amount_limit" placeholder="请输入数字"></a-input-number>
        <div class="tips">本活动总限制人数，0为不限制</div>
      </a-form-item>
      <a-form-item label="报名限制">
        <a-input-number :min="1" style="width: 320px" v-model="form.join_limit" placeholder="请输入数字"></a-input-number>
        <div class="tips">每人限制最多报几个名额</div>
      </a-form-item>
      <a-form-item label="需要报名">
        <a-radio-group v-model="form.need_join">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="需要审核">
        <a-radio-group v-model="form.need_app">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="邀请报名">
        <a-radio-group v-model="form.yaoqing">
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="优惠券">
        <a-select style="width: 320px" v-model="form.coupon_id" @change="selectCoupon">
          <a-select-option :value="0">请选择</a-select-option>
          <a-select-option v-for="(coupon, c) in couponList" :key="c" :value="coupon.id">{{coupon.name}} （满{{coupon.man}}减{{coupon.jian}}）</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="详细介绍">
        <Editor
          @callback="updateEditor"
          :data="form.content"
          folder="activity"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">创建活动</a-button>
    </div>

    <PosPicker v-if="pos_picker_show" @callback="gotPosition" />
  </div>
</template>

<style lang="scss" scoped>
.tips {
  font-size: 12px;
  color: red;
}
</style>

<script>
import moment from "moment";
import UploadFile from "../../components/uploadFile";
import Editor from "../../components/editor";
import PosPicker from "../../components/posPicker";

export default {
  components: { UploadFile, Editor, PosPicker },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      couponList: [],
      form: {
        exh_id: 0,
        name: "",
        logo: "",
        thumb: "",
        desc: "",
        content: "",
        place: "",
        addr: "",
        lat: "",
        lng: "",
        zhuban: "",
        xieban: "",
        fee: 0,
        start_at: null,
        end_at: null,
        join_start: null,
        join_end: null,
        need_join: 1,
        need_app: 0,
        amount_limit: 0,
        join_limit: 1,
        yaoqing: 0,
        coupon_id: 0,
        coupon_name: ''
      },
      pos_picker_show: false,
    };
  },
  async created() {
    this.form.exh_id = this.$route.query.exh_id;
    if (!this.form.exh_id) return this.$message.error("未找到贝展id");

    const r = await this.$axios.get("/exh/getInfo?id=" + this.form.exh_id);
    if (r.status == 1) {
      const exh = r.info;
      this.form.place = exh.place;
      this.form.addr = exh.addr;
      this.form.lat = exh.lat;
      this.form.lng = exh.lng;
      if (exh.start_at) this.form.start_at = moment(new Date(exh.start_at));
      if (exh.end_at) this.form.end_at = moment(new Date(exh.end_at));
      this.form.zhuban = exh.zhuban;
      this.form.xieban = exh.xieban;
    }

    // 获取优惠券
    const r2 = await this.$axios.get('/activity/getCouponList');
    this.couponList = r2.list;
  },
  methods: {
    moment,
    async sub() {
      const that = this;
      const r = await that.$axios.post("/activity/create", this.form);

      if (r.status == 1) {
        this.$router.push("/activity/list");
      }
    },

    uploaded(file) {
      this.form.logo = file.file_path;
    },

    uploaded2(file) {
      this.form.thumb = file.file_path;
    },

    updateEditor(data) {
      this.form.content = data;
    },

    gotPosition(pos) {
      this.pos_picker_show = false;
      this.form.place = pos.poiname;
      this.form.addr = pos.poiaddress;
      this.form.lat = pos.latlng.lat;
      this.form.lng = pos.latlng.lng;
    },

    selectCoupon () {
      for(let item of this.couponList){
        if(item.id == this.form.coupon_id){
          this.form.coupon_name = item.name
          break
        }
      }
    }
  },
};
</script>